import IconLogoShort from '@icons/LogoShort'
import * as S from './SuburbProfileHero.styled'
import AppraisalButton from '@global/Layout/Nav/AppraisalButton'

const SuburbProfileHero = ({ breadcrumbs, title, subTitle, h1, image, pdfDownload }) => {
  return (
    <S.SuburbProfileHero style={image ? { backgroundImage: `url(${image})` } : undefined}>
      <S.SuburbProfileHeroInner>
        {breadcrumbs}
        <S.SuburbProfileHeroContent>
          <S.Title>{title}</S.Title>
          <IconLogoShort />
          <S.SubTitle>{subTitle}</S.SubTitle>
          <S.H1 as='h1'>{h1}</S.H1>
          <S.SuburbProfileHeroActions>
            <AppraisalButton color='secondary' />
            {pdfDownload}
          </S.SuburbProfileHeroActions>
        </S.SuburbProfileHeroContent>
      </S.SuburbProfileHeroInner>
    </S.SuburbProfileHero>
  )
}

export default SuburbProfileHero
